import styled from 'styled-components'
import Muted from '../typography/muted'

const FormControl = styled.div`
  width: 100%;
  margin-bottom: ${props => props.theme.spacing.base500};

  label ${Muted} {
    display: block;
  }

  input,
  textarea,
  .react-datepicker-wrapper {
    display: block;
  }
`

export default FormControl
